export const BUNDLE_CONFIGURATION_STATE_NAME = 'bundleConfiguration';

export class LoadBundleConfigurationByIds {
  static type = `[${BUNDLE_CONFIGURATION_STATE_NAME}] LoadBundleConfigurationByIds`;
  constructor(public bundleConfigurationIds: string[]) {}
}
